import { Component, Input } from '@angular/core';
import { getCakeCartLineTotalPrice, ICakeCartLine } from '../../../cart';

@Component({
  standalone: false,
  selector: 'cake-total',
  templateUrl: './cake-total.component.html',
  styleUrls: ['./cake-total.component.scss']
})
export class CakeTotalComponent {
  @Input() cartLine: ICakeCartLine;
  @Input() currency = '';
  @Input() disabled: boolean;
  @Input() discount: number = null;
  @Input() extraPrice = 0;

  public getPrice() {
    if (!this.cartLine || !this.cartLine.size || !this.cartLine.variant) {
      return 'N/A';
    }

    return getCakeCartLineTotalPrice({line: this.cartLine, discount: this.discount}) + this.extraPrice;
  }
}
